import { partial } from 'lodash';
import { type } from '@mews/framework';
import GeneralApiComponent from '../generalApiComponent';
import createRequest from './misc/createRequest';
import searchable from './traits/searchable';

const BASE_URL = '/cities';
const onSuccess = ({ cities }: $TSFixMe) => cities;

export default function CityComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, GeneralApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);
    // @ts-expect-error $TSFixMeError: Argument of type '({ cities }: $TSFixMe) => any' is not assignable to parameter of type 'LodashIdentity'.
    return type.create(CityComponent, searchable(partial(request, '/search'), onSuccess));
}
